"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStorageGet = useStorageGet;
const swr_1 = __importDefault(require("swr"));
const useStorageClient_1 = require("./useStorageClient");
/**
 * Calls `storage.get` and returns an SWR response. SWR `revalidateOnFocus` option is set to `false`.
 *
 * @param entity - entity name
 * @param id - entity id, this is optional, if not set backend will not be called and result will not be returned
 * @param baseUrl - optional base URL
 * @param tokenProvider - optional token provider
 * @param config - custom SWR configuration object
 */
function useStorageGet(entity, id, baseUrl, tokenProvider, config) {
    const storage = (0, useStorageClient_1.useStorageClient)(entity, baseUrl, tokenProvider);
    return (0, swr_1.default)(id ? [`/platform/storage/${entity}/get`, id] : null, async ([, id]) => {
        return id ? storage.get(id) : undefined;
    }, config ?? {
        revalidateOnFocus: false,
    });
}
